/** 名片选择器懒加载壳（21d-2；ImageConfirmSheetLazy 同构，不进首屏块） */
import { useLazyModule } from './useLazyModule';
import type { ContactCardPickerProps } from './ContactCardPicker';

export function ContactCardPickerLazy(props: ContactCardPickerProps) {
  const { mod } = useLazyModule(() => import('./ContactCardPicker'));
  if (mod === null) return null; // 加载中不占位：浮层晚一帧出来比闪个空壳好
  return <mod.ContactCardPicker {...props} />;
}
